import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DataRequestsState } from '@/types/dataRequestsState';
import { EditBenefitCalculationSubmitParams } from '@/features/serviceModal/components/EditBenefitCalculationModal/types';
import { OverrideBenefitCalculationSubmitParams } from '@/features/serviceModal/components/OverrideBenefitCalculationModal/types';
import { BenefitCalculationDetailsModel } from './types/BenefitCalculationDetailsModel';

export type BenefitCalculationSliceState = {
  dataRequestsStates: {
    benefitCalculationDetails: DataRequestsState;
  };

  benefitCalculationDetails: BenefitCalculationDetailsModel;
};

const initialState: BenefitCalculationSliceState = {
  dataRequestsStates: {
    benefitCalculationDetails: {
      isLoading: false,
      isFetching: false,
      isSuccess: false,
      isError: false,
    },
  },

  benefitCalculationDetails: {
    benefitCalculationHeaderData: undefined,
    benefitCalculationDetailsData: undefined,
  },
};

const benefitCalculationDetailsSlice = createSlice({
  name: 'benefitCalculationDetails',
  initialState,
  reducers: {
    createBenefitCalculationDetails: (
      _state,
      _action: PayloadAction<{
        coverageId: string;
      }>,
    ) => {},
    getBenefitCalculationDetails: (
      _state,
      _action: PayloadAction<{
        coverageId: string;
      }>,
    ) => {},
    recalculateBenefitCalculationDetails: (
      _state,
      _action: PayloadAction<{
        coverageId: string;
        claimId: string;
      }>,
    ) => {},
    updateBenefitCalculationField: (_state, _action: PayloadAction<EditBenefitCalculationSubmitParams>) => {},
    overrideBenefitCalculationFields: (_state, _action: PayloadAction<OverrideBenefitCalculationSubmitParams>) => {},
    clearBenefitCalculationDetails(state) {
      state.benefitCalculationDetails = initialState.benefitCalculationDetails;
    },
    startLoadingBenefitCalculationDetails: (state) => {
      state.dataRequestsStates.benefitCalculationDetails = {
        isLoading: true,
        isFetching:
          !state.dataRequestsStates.benefitCalculationDetails.isError &&
          !state.dataRequestsStates.benefitCalculationDetails.isSuccess,
        isError: false,
        isSuccess: false,
      };
    },
    getBenefitCalculationDetailsSuccess: (state, action: PayloadAction<BenefitCalculationDetailsModel>) => {
      state.benefitCalculationDetails = action.payload;
      state.dataRequestsStates.benefitCalculationDetails = {
        isLoading: false,
        isFetching: false,
        isError: false,
        isSuccess: true,
      };
    },
    getBenefitCalculationDetailsError: (state) => {
      state.dataRequestsStates.benefitCalculationDetails = {
        isLoading: false,
        isFetching: false,
        isError: true,
        isSuccess: false,
      };
    },
    createBenefitCalculationDetailsError: (state) => {
      state.dataRequestsStates.benefitCalculationDetails = {
        isLoading: false,
        isFetching: false,
        isError: true,
        isSuccess: false,
      };
    },
    recalculateBenefitCalculationDetailsError: (state) => {
      state.dataRequestsStates.benefitCalculationDetails = {
        isLoading: false,
        isFetching: false,
        isError: true,
        isSuccess: false,
      };
    },
  },
});

export const {
  createBenefitCalculationDetails,
  getBenefitCalculationDetails,
  recalculateBenefitCalculationDetails,
  getBenefitCalculationDetailsSuccess,
  getBenefitCalculationDetailsError,
  createBenefitCalculationDetailsError,
  recalculateBenefitCalculationDetailsError,
  clearBenefitCalculationDetails,
  startLoadingBenefitCalculationDetails,
  updateBenefitCalculationField,
  overrideBenefitCalculationFields,
} = benefitCalculationDetailsSlice.actions;

export const benefitCalculationDetailsReducer = benefitCalculationDetailsSlice.reducer;
export const benefitCalculationDetailsReducerPath = benefitCalculationDetailsSlice.reducerPath;
